import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams, ToastController, AlertController } from 'ionic-angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Globals } from "../../../../globals";
import { ProvidersServices } from "../../../providers/services";
import { CustomersListPage } from "../../customers-list/customers-list";
import { CustomersServices } from '../../services';
import { TranslateService } from '@ngx-translate/core';
import { AlegraServices } from '../../../services/alegraServices';
import { SearchServices } from '../../../services/searchs';
import { InvoicesServices } from '../../../invoices/services';
import { SalesListPage } from '../../../sales/sales-list/sales-list';

/**
 * Pantalla para crear un nuevo plato o update de uno existente
 * En el params recibimos si es un plato existente o uno nuevo. En caso de ser
 * UPDATE tenenmos que rellenar los campos del formulario
 */

@Component({
  selector: 'page-customers-create-info.html',
  templateUrl: 'customers-create-info.html',
})
export class CustomersCreateInfoPage {
  public form: FormGroup;
  customer_uid: any;
  update_state: boolean = false;
  address: any;
  quick_create: boolean = false;
  alegra_contact_id: any;
  callback: any;
  canDelete: boolean = false;
  loadCanDelete: boolean = false;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public fb: FormBuilder,
    public globals: Globals,
    private toastCtrl: ToastController,
    public providersServices: ProvidersServices,
    public customersServices: CustomersServices,
    public alertCtrl: AlertController,
    public translate: TranslateService,
    private alegraServices: AlegraServices,
    public searchService: SearchServices,
    public invoicesServices: InvoicesServices) {

    //Params
    this.update_state = this.navParams.get('update_state');
    this.customer_uid = this.navParams.get('customer_uid');
    this.callback = this.navParams.get("callback")

    //loadingPopup
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: ''
    });
    loadingPopup.present();
    this.alegra_contact_id = this.navParams.get('alegra_contact_id');
    loadingPopup.dismiss();

    let EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])+\.[a-z0-9]([a-z0-9-]*[a-z0-9])*$/i;
    if (this.update_state) {
      this.form = fb.group({
        name: [this.navParams.get('name'), Validators.compose([Validators.required])],
        business_name: [this.navParams.get('business_name')],
        business_number: [this.navParams.get('business_number')],
        email: [this.navParams.get('email'), Validators.compose([Validators.pattern(EMAIL_REGEXP)])],
        phone: [this.navParams.get('phone')],
        address: [this.navParams.get('address')],
        note: [this.navParams.get('note')],
      });
      this.globals.GAtrackView('Customers', 'Customers - View ', this.globals.restaurant.email, 'View', 'View customer', 'Customers', '');
      //revisar si hay facturas por generar para evitar que borre cliente
      this.checkIfCustomerHasPendingInvoice();


    } else {
      this.form = fb.group({
        name: ['', Validators.compose([Validators.required])],
        business_name: [''],
        business_number: [''],
        email: ['', Validators.compose([Validators.pattern(EMAIL_REGEXP)])],
        phone: [''],
        address: [''],
        note: [''],
      });
    }


  }
  async checkIfCustomerHasPendingInvoice() {
    this.loadCanDelete = false;
    this.canDelete = await this.invoicesServices.getIfCustomerHasPendingInvoice(this.customer_uid);
    this.loadCanDelete = true;
  }


  submit() {
    if (this.form.valid) {
      if (!this.update_state) {
        this.insert();
      } else {
        this.update();
      }
    } else {
      if (this.form.controls.email.status == 'INVALID') {
        let toast = this.toastCtrl.create({
          message: this.translate.instant('instant-formato-email-no-valido'),
          duration: 3000,
          position: 'bottom'
        });
        toast.present();
      } else {
        let toast = this.toastCtrl.create({
          message: this.translate.instant('customer-añade-nombre-cliente'),
          duration: 3000,
          position: 'bottom'
        });
        toast.present();
      }
    }
  }

  insert() {

    if (this.addres_format_google) {//Comprovamos si hay una adress formatada y le ponemos al form. Si no lo hacemos la primera vez no lo encuntra bien.
      this.form.value.address = this.addres_format_google;
    }

    this.providersServices.afs.collection('customers').add({
      'UID_RESTAURANT': this.globals.restaurant_uid,
      'name': this.form.value.name,
      'business_name': this.form.value.business_name,
      'business_number': this.form.value.business_number,
      'email': this.form.value.email,
      'phone': this.form.value.phone,
      'address': this.form.value.address,
      'note': this.form.value.note,
      'created_at': new Date()
    }).then(async doc => {
      this.globals.GAtrackView('Customers', 'Customers - Create ', this.globals.restaurant.email, 'Create/Update', 'Create customer', 'Customers', this.form.value.name);
      //Recuperamos el cliente
      let customer = await this.customersServices.getCustomer(doc.id);
      //Seleccionamos el cliente en el buscador
      this.searchService.selectCustomer(customer);


      //Get the UID Document
      if (this.providersServices.quick_create) {
        this.providersServices.quick_create = false;
        this.navCtrl.pop();
      } else {
        this.navCtrl.push(CustomersListPage, {
          //update: false,
          //delibery_note_uid: doc.id,
        });
      }
    });
  }

  update() {

    if (this.addres_format_google) {//Comprovamos si hay una adress formatada y le ponemos al form. Si no lo hacemos la primera vez no lo encuntra bien.
      this.form.value.address = this.addres_format_google;
    }

    this.providersServices.afs.collection('customers').doc(this.customer_uid).update({
      'name': this.form.value.name,
      'business_name': this.form.value.business_name,
      'business_number': this.form.value.business_number,
      'email': this.form.value.email,
      'phone': this.form.value.phone,
      'address': this.form.value.address,
      'note': this.form.value.note,
    }).then(async () => {
      this.globals.GAtrackView('Customers', 'Customers - Update ', this.globals.restaurant.email, 'Create/Update', 'Update customer', 'Customers', this.form.value.name);
      //si tienen relacion(alegra_contact_id) con alegra hacer tambien update
      if (this.alegra_contact_id) {
        await this.alegraServices.editContact(this.alegra_contact_id, this.form.value.name, this.form.value.email);
      }
      //poner los datos actualizados para poder recogerlos a la pagina que vuelva el pop.
      this.navCtrl.getPrevious().data.name = this.form.value.name;
      this.navCtrl.getPrevious().data.business_name = this.form.value.business_name;
      this.navCtrl.getPrevious().data.business_number = this.form.value.business_number;
      this.navCtrl.getPrevious().data.email = this.form.value.email;
      this.navCtrl.getPrevious().data.phone = this.form.value.phone;
      this.navCtrl.getPrevious().data.address = this.form.value.address;
      this.navCtrl.getPrevious().data.note = this.form.value.note;
      this.navCtrl.pop();

    });
  }

  addres_format_google: any;
  public handleAddressChange(address) {
    this.addres_format_google = address.formatted_address;
    this.form.value.address = address.formatted_address;
  }



  delete() {


    let alert = this.alertCtrl.create({
      title: this.translate.instant('general-eliminar-cliente'),
      message: this.translate.instant('instant-seguro-quieres-eliminarlo'),
      buttons: [
        {
          text: this.translate.instant('general-no'),
          role: 'cancel',
          handler: () => { }
        },
        {
          text: this.translate.instant('general-si'),
          handler: () => {
            this.globals.GAtrackView('Customers', 'Customers - Delete ', this.globals.restaurant.email, 'Delete', 'Delete customer', 'Customers', this.form.value.name);
            this.customersServices.afs.doc('customers/' + this.customer_uid).delete();
            this.redirect();
          }
        }
      ]
    });
    alert.present();


  }

  async redirect() {
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: ''
    });
    loadingPopup.present();
    await this.globals.delay(1000);
    this.navCtrl.pop();
    this.navCtrl.pop();
    loadingPopup.dismiss();
  }

  openSales() {
    this.navCtrl.push(SalesListPage);
  }

}




// WEBPACK FOOTER //
// ./src/pages/customers/customers-create/customers-create-info/customers-create-info.ts